/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-02-01T17:22:46-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-14T15:30:55-07:00
*/



import React, { Component } from 'react';
import { Link } from 'react-router';
import {whoPays} from "../../../mt";
import {tsDate} from "../../../common";
import { css, StyleSheet } from 'aphrodite/no-important';
import { spacing, type, color, textColor, borders, leading, dimensions } from '../../../style';
import Modal from '../../common/Modal';
import TripDates from '../../blocks/TripDates';
import Headline from '../../common/Headline';
import Button from '../../blocks/Button';
import { MenuList, MenuListItem } from '../../blocks/MenuList';

const style = StyleSheet.create({
  container: {
    // remove list styling applied to LI's
    listStyle: 'none',
  },

  tripTitle: {
    ...spacing.MARGIN_BOTTOM_SM
  },


  tripItem: {
    display: 'block',
    padding: '17px 0',
    borderBottom: borders.DEFAULT,

    [dimensions.SCREEN_MIN_MD]: {
      ...spacing.PADDING_MD,
    }
  },

  tripDates: {
    [dimensions.SCREEN_MIN_MD]: {
      width: 380
    }
  },


  description: {
    ...spacing.MARGIN_0,
    ...spacing.MARGIN_BOTTOM_SM,
    ...textColor.DARKER,
    wordBreak: 'break-word'
  },

  likes: {
    color: color.BRAND_1,
    ...type.BOLD,
    textTransform: 'uppercase'
  },

  actionBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  }

});

class TripCard extends Component {
  constructor(props) {
    super(props);
    this.state = { modalOpen: false };

  }


  render() {
    let trip = this.props.data;
    return (
      <li className={css(style.container)}>
        <Link className={css(style.tripItem)} to={`/trip/${trip.id}`} >
          <Headline extraStyles={{...spacing.MARGIN_BOTTOM_SM}}>
            {trip.city}, {trip.region}, {trip.country}
          </Headline>

          <div className={css(style.tripDates)}>
            <TripDates leaveDt={trip.leaving_dt.date} returnDt={trip.returning_dt.date} />
          </div>
          <div>{whoPays(trip.who_pays)}</div>
          <div className={css(style.actionBar)}>
            <div className={css(style.likes)}>{trip.likes} Asked to join this trip</div>

          </div>

        </Link>

      </li>
    );
  }
}

export default TripCard;



// WEBPACK FOOTER //
// ./src/components/pages/Trips/TripCard.jsx